import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { fetchMindPattersStoreMP } from '../api';
import { mindPatternsStoreMPActions } from './actions';
import { SYSTEM_ID_NEXT_ASSESSMENT } from '../constants';
import { systemActions } from '../system';

export function* saveMindPatternsStoreMP({ payload }) {
  yield call(fetchMindPattersStoreMP, payload.data);
  yield put(systemActions.loadSystem(SYSTEM_ID_NEXT_ASSESSMENT));
}
//=====================================
//  WATCHERS
//-------------------------------------

export function* watchMindPatternsStoreMP() {
  yield takeLatest(mindPatternsStoreMPActions.SAVE_MINDPATTERNS_STORE_MP, saveMindPatternsStoreMP);
}

//=====================================
//  ROOT
//-------------------------------------

export const mindPatternsStoreMPSagas = [
  fork(watchMindPatternsStoreMP)
];
